import { defineComponent as _defineComponent } from 'vue';
import useNavigation from '@/composables/navigation';
export default /*#__PURE__*/ _defineComponent({
    __name: 'navigation-bar',
    setup(__props, { expose: __expose }) {
        __expose();
        const { toggleMenu } = useNavigation();
        const __returned__ = { toggleMenu };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
